/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ArticlePastSearchContract,
    ArticlePastSearchContractFromJSON,
    ArticlePastSearchContractFromJSONTyped,
    ArticlePastSearchContractToJSON,
} from './ArticlePastSearchContract';

/**
 * 
 * @export
 * @interface ArticlePastSearchContractResponse
 */
export interface ArticlePastSearchContractResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof ArticlePastSearchContractResponse
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof ArticlePastSearchContractResponse
     */
    message: string;
    /**
     * 
     * @type {ArticlePastSearchContract}
     * @memberof ArticlePastSearchContractResponse
     */
    data: ArticlePastSearchContract | null;
}

export function ArticlePastSearchContractResponseFromJSON(json: any): ArticlePastSearchContractResponse {
    return ArticlePastSearchContractResponseFromJSONTyped(json, false);
}

export function ArticlePastSearchContractResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchContractResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ArticlePastSearchContractFromJSON(json['data']),
    };
}

export function ArticlePastSearchContractResponseToJSON(value?: ArticlePastSearchContractResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ArticlePastSearchContractToJSON(value.data),
    };
}

